/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../../../../../../components/Form/Button";
import { Wrapper, PlusIcon, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-state-grid.svg");

type ProjectEmptySectionProps = {
  onAdd: () => void;
  buttonLabel: string;
  descriptionScreen: string;
  icon?: string;
};

export const ProjectEmptySection: React.FC<ProjectEmptySectionProps> = (props) => {
  const { buttonLabel, descriptionScreen, onAdd, icon } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      data-cy="despatch-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={icon || defaultIcon} alt="empty state" />
      </Grid>
      <Grid item xs={8}>
        <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
      </Grid>
      <DescriptionContainer item xs={6}>
        <Description>{descriptionScreen}</Description>
      </DescriptionContainer>
      <Grid item xs={12}>
        <Button onClick={onAdd} customColor={Color.SECONDARY}>
          <PlusIcon color="#ffffff" size={16} />
          {buttonLabel}
        </Button>
      </Grid>
    </Wrapper>
  );
};
